// services/billing.service.ts — provider subscription tiers (Free / Pro / Enterprise)
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PlanInfo {
  tier: string;
  configured: boolean;
}

export interface SubscriptionStatus {
  tier: string;
  status: string | null;
  trialEligible?: boolean;
  trialEnd?: string | null;
  currentPeriodEnd?: string | null;
  cancelAtPeriodEnd?: boolean;
  cardBrand?: string | null;
  cardLast4?: string | null;
}

export interface SubscriptionResult {
  subscriptionId: string;
  status: string;
  requiresAction: boolean;
  actionType: 'payment' | 'setup' | null;
  clientSecret: string | null;
  trialEnd: string | null;
  currentPeriodEnd: string | null;
}

@Injectable({ providedIn: 'root' })
export class BillingService {
  private apiUrl = environment.apiUrl + 'Billing/';

  constructor(private http: HttpClient) {}

  getPlans(): Observable<PlanInfo[]> {
    return this.http.get<PlanInfo[]>(`${this.apiUrl}plans`);
  }

  getSubscription(userId: number): Observable<SubscriptionStatus> {
    return this.http.get<SubscriptionStatus>(`${this.apiUrl}subscriptions/${userId}`);
  }

  subscribe(userId: number, tier: string, paymentMethodId?: string): Observable<SubscriptionResult> {
    return this.http.post<SubscriptionResult>(`${this.apiUrl}subscriptions/${userId}`, { tier, paymentMethodId });
  }

  cancelSubscription(userId: number): Observable<SubscriptionStatus> {
    return this.http.post<SubscriptionStatus>(`${this.apiUrl}subscriptions/${userId}/cancel`, {});
  }

  resumeSubscription(userId: number): Observable<SubscriptionStatus> {
    return this.http.post<SubscriptionStatus>(`${this.apiUrl}subscriptions/${userId}/resume`, {});
  }
}
